import { useEffect, useRef } from "react";
import { Toaster, toast } from "sonner";

// Country name + flag emoji pairs used for the fake live-activity feed.
const COUNTRIES = [
  ["United States", "🇺🇸"],
  ["United Kingdom", "🇬🇧"],
  ["Germany", "🇩🇪"],
  ["France", "🇫🇷"],
  ["Canada", "🇨🇦"],
  ["Australia", "🇦🇺"],
  ["Japan", "🇯🇵"],
  ["Singapore", "🇸🇬"],
  ["United Arab Emirates", "🇦🇪"],
  ["Switzerland", "🇨🇭"],
  ["Netherlands", "🇳🇱"],
  ["Sweden", "🇸🇪"],
  ["Spain", "🇪🇸"],
  ["Italy", "🇮🇹"],
  ["Brazil", "🇧🇷"],
  ["South Africa", "🇿🇦"],
  ["India", "🇮🇳"],
  ["South Korea", "🇰🇷"],
  ["Norway", "🇳🇴"],
  ["Hong Kong", "🇭🇰"],
];

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

function buildMessage() {
  const [country, flag] = pick(COUNTRIES);
  const action = Math.random() < 0.5 ? "withdrew" : "made a deposit of";
  // Random amount between $10k and $500k, rounded to the nearest $100.
  const amount = Math.round((10000 + Math.random() * 490000) / 100) * 100;
  const formatted = amount.toLocaleString("en-US");
  return `A user from ${country} ${flag} just ${action} $${formatted}`;
}

export default function ActivityToaster() {
  const timeoutRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    const schedule = () => {
      // Random interval between 5 and 10 seconds.
      const delay = 5000 + Math.random() * 5000;
      timeoutRef.current = setTimeout(() => {
        if (cancelled) return;
        toast(buildMessage());
        schedule();
      }, delay);
    };

    schedule();

    return () => {
      cancelled = true;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return <Toaster position="bottom-left" theme="dark" richColors closeButton />;
}
